import {statusLicitacao} from '../constants'

const filtroStatusLicitacao = function (status) {
    return statusLicitacao.hasOwnProperty(status) ? statusLicitacao[status] : status
}

export default filtroStatusLicitacao
